export default {
  title: 'SAAS Super Rate System',
  description: 'Intelligent rate query and management system',

  // General address fields
  address: {
    detailAddress: 'Detailed Address',
    postalCode: 'Postal Code',
    district: 'Region'
  },

  // Common display fields
  display: {
    totalItems: '{count} {name} total',
    port: 'Ports(s)',
    pod: 'POD',
    pol: 'POL',
    warehouse: 'Warehouse(s)',
    warehouseCode: 'Warehouse Code(s)',
    region: 'Region'
  },

  // Third Party Address Select Component
  thirdPartyAddressSelect: {
    country: 'Country',
    state: 'State',
    city: 'City',
    district: 'District',
    township: 'Township / Town / Street',
    postalCode: 'Postal Code (Optional)',
    postalCodePlaceholder: 'Enter postal code',
    detailAddress: 'Detailed Address',
    detailAddressPlaceholder: 'Enter detailed address',
    countryPlaceholder: 'Select country',
    statePlaceholder: 'Select state',
    cityPlaceholder: 'Select city',
    districtPlaceholder: 'Select district',
    townshipPlaceholder: 'Select township, town or street',
    error: {
      country: 'Failed to select country, please try again',
      state: 'Failed to select state, please try again',
      city: 'Failed to select city, please try again',
      district: 'Failed to select district, please try again'
    }
  },

  // Reset function specific i18n
  reset: {
    buttonText: 'Reset',
    confirmTitle: 'Confirm Reset',
    confirmMessage: 'Are you sure you want to reset and clear all fields?',
    confirmButton: 'Confirm',
    cancelButton: 'Cancel',
    successMessage: 'All fields have been reset'
  },

  // Enum translations
  enums: {
    // Pricing Nature
    pricingNature: {
      selfPricing: 'FAK',
      customerPricing: 'Customer Pricing',
      overseasAgentPricing: 'Overseas Agent Pricing',
      noPricing: 'No Pricing',
      peerPricing: 'Peer Pricing',
      bcoContract: 'NAC/FIX',
      afcPricing: 'AFC Pricing',
      mixedPricing: 'Blended Pricing'
    },

    // Commodity
    commodity: {
      fak: 'FAK',
      dangerousGoods: 'Dangerous Goods',
      specialContainer: 'Special Container',
      frozenGoods: 'Frozen Goods',
      chemicalGoods: 'Chemical Goods',
      textileGoods: 'Textile Goods',
      other: 'Other'
    },

    // Space Guarantee
    spaceGuarantee: {
      guarantee20: 'Yes (20 TEU/Month)',
      guarantee50: 'Yes (50 TEU/Month)',
      guarantee100: 'Yes (100 TEU/Month)',
      guarantee300: 'Yes (300 TEU/Month)',
      noGuarantee: 'None'
    },

    // Contract Status
    contractStatus: {
      enabled: 'Enabled',
      disabled: 'Disabled'
    }
  },

  // Root level common field translations
  freeContainerDays: 'Free Container Days',
  demurrageFreeDays: 'Demurrage Free Days',

  // Delivery Address Type
  deliveryAddressType: {
    thirdParty: 'Third Party Address',
    amazon: 'Amazon Warehouse',
    yicang: 'Easy Warehouse'
  }
}
